export const languageNames = Object.freeze({
  de: "Deutsch",
  de_CH: "Deutsch (Schweiz)",
  en: "English (US)",
  en_GB: "English (UK)",
  fr: "Français",
  es: "Español",
  pt: "Português",
  hu: "Magyar",
  pl: "Polski",
  it: "Italiano",
  uk_UA: "українська",
});

export type LanguageKey = keyof typeof languageNames;
type ToISOLanguageKey<Key extends string> = Key extends `${infer Language}_${infer Region}`
  ? `${Language}-${Region}`
  : Key;
export type ISOLanguageKey = ToISOLanguageKey<LanguageKey>;

export const defaultLanguage = "de" satisfies ISOLanguageKey;

export const flagMap = Object.freeze({
  de: "fi fi-de",
  de_CH: "fi fi-ch",
  en: "fi fi-us",
  en_GB: "fi fi-gb",
  fr: "fi fi-fr",
  es: "fi fi-es",
  pt: "fi fi-pt",
  hu: "fi fi-hu",
  pl: "fi fi-pl",
  it: "fi fi-it",
  uk_UA: "fi fi-ua",
} satisfies Record<LanguageKey, string>);
